export default {
      id: "parents-usage",
      viewBox: "0 0 27 33",
      url: __webpack_public_path__ + "sprite.svg#parents",
      toString: function () {
        return this.url;
      }
    }